var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeywordsMaping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Keywords_Maping",
    "data-name": "Keywords Maping",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "keyword",
    transform: "translate(-13.867 498.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M16.065-495.935c-.053.053-.065.182-.065.78a2.513,2.513,0,0,0,.049.764,16.443,16.443,0,0,0,2.223.048c2.106,0,2.175,0,2.215-.077a4.032,4.032,0,0,0,.04-.764c0-.61-.008-.691-.073-.748a8.289,8.289,0,0,0-2.2-.069A8.9,8.9,0,0,0,16.065-495.935Z",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M162.073-495.956c-.065.036-.073.117-.073.776a2.644,2.644,0,0,0,.049.788,4.441,4.441,0,0,0,1.092.048c.986,0,1.043,0,1.083-.077a3.853,3.853,0,0,0,.04-.74c0-.534-.012-.679-.065-.752-.061-.089-.073-.089-1.059-.089A6.754,6.754,0,0,0,162.073-495.956Z",
    transform: "translate(-139.984)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M252.049-495.951a2.605,2.605,0,0,0-.049.78,2.607,2.607,0,0,0,.049.78,14.514,14.514,0,0,0,2.082.048c1.965,0,2.033,0,2.074-.077a4.034,4.034,0,0,0,.04-.764c0-.61-.008-.691-.073-.748S255.9-496,254.1-496A14.049,14.049,0,0,0,252.049-495.951Z",
    transform: "translate(-226.252)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M391.073-495.956c-.065.036-.073.117-.073.776a2.643,2.643,0,0,0,.049.788c.069.069,4.079.069,4.148,0a2.512,2.512,0,0,0,.049-.764c0-.6-.012-.728-.065-.78a7.886,7.886,0,0,0-2.05-.065A20.5,20.5,0,0,0,391.073-495.956Z",
    transform: "translate(-359.511)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M16.089-416.935c-.085.061-.089.085-.089.78,0,.647.008.728.073.784s.271.069,2.062.069a7.853,7.853,0,0,0,2.046-.065c.053-.053.065-.182.065-.784,0-.7,0-.724-.089-.784A8.33,8.33,0,0,0,18.122-417,8.33,8.33,0,0,0,16.089-416.935Z",
    transform: "translate(0 -75.747)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M155.081-416.919c-.073.073-.081.133-.081.78,0,.631.008.711.073.768s.267.069,2.046.069c1.282,0,2-.016,2.05-.04.073-.04.077-.093.077-.788,0-.724,0-.744-.089-.8a8.383,8.383,0,0,0-2.042-.065C155.214-417,155.158-417,155.081-416.919Z",
    transform: "translate(-133.259 -75.747)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M294.162-416.893c-.146.053-.162.137-.162.821,0,.542.012.687.065.76.061.089.073.089,1.067.089.861,0,1.015-.008,1.067-.065s.065-.182.065-.784c0-.7,0-.724-.089-.784s-.243-.065-1.023-.061C294.643-416.917,294.194-416.9,294.162-416.893Z",
    transform: "translate(-266.546 -75.826)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M384.081-416.919c-.073.073-.081.133-.081.76,0,.546.012.7.065.768l.061.089h2.135c2.017,0,2.139,0,2.2-.073s.069-.182.069-.788c0-.687,0-.712-.089-.772a9.463,9.463,0,0,0-2.183-.065C384.214-417,384.158-417,384.081-416.919Z",
    transform: "translate(-352.794 -75.747)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M150.438-340.9a6.579,6.579,0,0,0-2.675,1.061,6.178,6.178,0,0,0-2.587,4.715,6.1,6.1,0,0,0,5.124,6.357,7.425,7.425,0,0,0,2.294-.05,6.171,6.171,0,0,0,4.682-4.61,4.617,4.617,0,0,0,.122-1.426,4.615,4.615,0,0,0-.149-1.481,7.2,7.2,0,0,0-.94-2.023A6.233,6.233,0,0,0,150.438-340.9Zm2.128,1.432a4.892,4.892,0,0,1,3.184,2.808,3.921,3.921,0,0,1,.321,1.89,3.254,3.254,0,0,1-.155,1.327,4.872,4.872,0,0,1-2.4,2.9,3.935,3.935,0,0,1-2.217.5,3.731,3.731,0,0,1-2.128-.47,4.823,4.823,0,0,1-2.521-3.013,5.886,5.886,0,0,1-.111-2.051,4.846,4.846,0,0,1,3.792-3.969A5.993,5.993,0,0,1,152.566-339.473Z",
    transform: "translate(-125.425 -147.873)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M16.692-277a.853.853,0,0,0-.508.428c-.061.114-.064.149-.072.74-.011.769.005.846.229,1.07.247.247.2.24,1.738.24H19.4l-.08-.245a3.455,3.455,0,0,1,.029-2.1c.032-.08.056-.149.056-.154S16.75-277.02,16.692-277Z",
    transform: "translate(-0.042 -206.929)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M372.105-276.841c.037.088.152.476.184.62a4.1,4.1,0,0,1,.035.6,2.794,2.794,0,0,1-.16,1.064l-.064.186h1.325c1.538,0,1.49.008,1.738-.24.224-.224.24-.3.229-1.07-.008-.612-.008-.623-.08-.753a.832.832,0,0,0-.367-.362l-.12-.064-1.365-.008A7.031,7.031,0,0,0,372.105-276.841Z",
    transform: "translate(-339.728 -207.084)",
    fill: "#81cfe2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(22.379 -484.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M7.644,7.329H4.87a1.993,1.993,0,1,0,0,1.329h.116l.664.664.664-.664.664.664L8.308,7.98ZM2.993,8.99a1,1,0,1,1,1-1A1,1,0,0,1,2.993,8.99Z",
    transform: "translate(-1 -6)",
    fill: "#81cfe2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeywordsMaping);
export default __webpack_public_path__ + "static/media/keywordsMaping.01b43825ff9ee8d3a4ffebb9431f1b76.svg";
export { ForwardRef as ReactComponent };